import React, { useState } from "react";
import {
  TextareaAutosize,
  Grid,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

function UniqueOptions(props) {
  const handleActionChange = (event) => {
    let errorMessage =
      event.target.value == "error"
        ? props.options.errorMessage
        : props.options.warningMessage;
    props.handleUniqueValueChange(event.target.value, errorMessage);
  };

  const handleMessageChange = (event) => {
    props.handleUniqueValueChange(props.options.action, event.target.value);
  };

  return (
    <Grid container key={"test"} direction="column">
      <RadioGroup
        aria-label="unique option"
        name="unique option"
        value={props.options.action}
        onChange={handleActionChange}
      >
        <FormControlLabel
          value="error"
          control={<Radio />}
          label="don't allow duplicate entries"
        />
        <FormControlLabel
          value="warning"
          control={<Radio />}
          label="allow duplicate entries with a warning message"
        />
      </RadioGroup>
      <span>{props.options.action.capitalize() + " Message"}</span>
      <TextareaAutosize
        variant="outlined"
        fullWidth
        rowsMin={2}
        placeholder="Field Name"
        autoFocus
        value={props.options.message}
        name="column_name"
        onChange={handleMessageChange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleMessageChange(e);
            e.preventDefault();
          }
        }}
        style={{ width: "100%" }}
      />
    </Grid>
  );
}

export default UniqueOptions;
